import { CALL_API } from "admin/middlewares/api";

export const SMS_TEMPLATES_GET_REQUEST = "SMS_TEMPLATES_GET_REQUEST";
export const SMS_TEMPLATES_GET_SUCCESS = "SMS_TEMPLATES_GET_SUCCESS";
export const SMS_TEMPLATES_GET_ERROR = "SMS_TEMPLATES_GET_ERROR";

export function get_sms_templates() {
  let uri = "/api/admin/system/maintenance/templates/smstemplates";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        SMS_TEMPLATES_GET_REQUEST,
        SMS_TEMPLATES_GET_SUCCESS,
        SMS_TEMPLATES_GET_ERROR,
      ],
    },
  };
}

export const SMS_TEMPLATE_SET_REQUEST = "SMS_TEMPLATE_SET_REQUEST";
export const SMS_TEMPLATE_SET_SUCCESS = "SMS_TEMPLATE_SET_SUCCESS";
export const SMS_TEMPLATE_SET_ERROR = "SMS_TEMPLATE_SET_ERROR";

export function set_sms_template(templateType, template, expectedVersion) {
  let uri = "/api/admin/system/settings/setsmstemplate";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      data: {
        ExpectedVersion: expectedVersion,
        Type: templateType,
        Template: template,
      },
      types: [
        SMS_TEMPLATE_SET_REQUEST,
        SMS_TEMPLATE_SET_SUCCESS,
        SMS_TEMPLATE_SET_ERROR,
      ],
    },
  };
}
